import React from 'react'
import { useParams } from 'react-router-dom'
import { CATEGORY, PRODUCT } from './AdminPanelOperations';
import { useEffect, useState } from 'react';
import { Box, Grid, Typography, useForkRef } from '@mui/material';
import TextInput from '../components/input/TextInput';
import { getCategoryByBranchIdHttp } from '../services/CategoryService';
import { getBranchOptionsHttp } from '../services/OptionService';
import SelectOption from '../components/input/SelectOption';
import { useFormik } from 'formik';

function AdminPanelOrder() {
    let {entity} = useParams();
    const [data, setData] = useState([])
    const [branchOptions, setBranchOptions] = useState([]);
    const [branchId, setBranchId] = useState();
    const [categoryId, setCategoryId] = useState();

    const getData = () => {
        if(entity===CATEGORY && branchId){
            getCategoryByBranchIdHttp(branchId).then((resp)=>formik.setValues(resp.data))
        }
        else if (entity===PRODUCT){
            //getProducts
        }
    }

    const formik = useFormik({

    })

    const handleOrderChange = (order,dataIndex) => {
        const newData = formik.values;
        newData[dataIndex].order = order;
        console.log(newData);
        formik.setValues((prev)=>{
                const newData = { ...prev[dataIndex] };
                console.log(newData)
                newData["order"] = order;
                console.log(newData,order)
                prev[dataIndex] = newData;
                console.log(prev)
                return prev;
            }
        )
    }

    useEffect(() => {
        getBranchOptionsHttp().then((resp)=>setBranchOptions(resp.data))
      }, [])

    useEffect(() => {
      getData()
    }, [branchId,categoryId])

  return (
    <Box>
        <pre>{JSON.stringify(formik.values,null,2)}</pre>
        <SelectOption
            label="Şube"
            name="branchId"
            options={branchOptions}
            value={branchId}
            onChange={(e)=>setBranchId(e.target.value)}
        />
        {
            // data.length>0 && data.map((row, index)=> 
            //     <Grid container>
            //         <Grid item>
            //             <Typography>
            //                 {row.name}
            //             </Typography>
            //         </Grid>
            //         <Grid item>
            //             <TextInput 
            //                 name="order"
            //                 value={data[index]["order"]}
            //                 onChange={(e)=>handleOrderChange(e.target.value,index)}
            //             />
            //         </Grid>
            //     </Grid>
            // )
            formik.values.length>0 && formik.values.map((row, index)=> 
                <Grid container>
                    <Grid item>
                        <Typography>
                            {row.name}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <TextInput 
                            name="order"
                            value={formik.values[index]["order"]}
                            onChange={(e)=>handleOrderChange(e.target.value,index)}
                        />
                    </Grid>
                </Grid>
            )
        }
    </Box>
  )
}

export default AdminPanelOrder